import React, { useMemo } from 'react';
import { InfoStripContainer } from './styles';
import theme from '../../../../../theme';
var _getColors = function (level) {
    switch (level) {
        case 'error':
            return {
                color: theme.colors.tfwErrorRed,
                backgroundColor: theme.colors.tfwErrorBackground,
                borderColor: theme.colors.tfwErrorRed,
            };
        case 'warning':
        default:
            return {
                color: theme.colors.tfwWarning,
                backgroundColor: theme.colors.tfwWarningBackground,
                borderColor: theme.colors.tfwWarningBorder,
            };
    }
};
var InfoStrip = function (_a) {
    var level = _a.level, content = _a.content;
    var _colors = useMemo(function () { return _getColors(level); }, [level]);
    return (React.createElement(InfoStripContainer, { color: _colors.color, backgroundColor: _colors.backgroundColor, escapeHtml: true, inputText: content }));
};
export default InfoStrip;
